import Image from 'next/image'
import PropTypes from 'prop-types'
import { CSSProperties, memo, ReactElement } from 'react'

import { BlogPropType } from '@/propTypes'
import dayjs from 'dayjs'
import Container from './style'

interface BlogImage {
  url: string
}

interface BlogInterface {
  link: string
  slug: string
  title: string
  published_at: string | Date
  image_1: BlogImage
}

interface Props {
  blog: BlogInterface
  style?: CSSProperties
  className?: string
  id?: string
}

function Item({ id, blog, className, style }: Props): ReactElement {
  const imgSrc = blog?.image_1?.url ?? ''
  const alt = blog?.slug || blog?.title || 'blog'

  return (
    <Container
      id={id}
      className={className}
      style={style ?? { display: 'flex', flexDirection: 'column' }}
      href={blog.link}
      target="_blank"
      rel="noreferrer"
    >
      {/* Aspect-ratio wrapper so layout doesn't jump */}
      <figure
        style={{
          position: 'relative',
          width: '100%',
          aspectRatio: '16 / 9',
          overflow: 'hidden',
          borderRadius: '12px',
        }}
      >
        <Image
          src={imgSrc}
          alt={alt}
          layout="fill"
          unoptimized
          quality={75}
          sizes="(max-width: 768px) 92vw, (max-width: 1280px) 80vw, 1200px"
          loading="lazy"
          objectFit="cover"
        />
      </figure>

      <h1>{blog.title}</h1>
      <p style={{ marginTop: 'auto' }}>
        {dayjs(blog.published_at).format('DD/MM/YYYY')}
      </p>
    </Container>
  )
}

Item.propTypes = {
  blog: BlogPropType.isRequired,
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}

Item.defaultProps = {
  className: '',
}

export default memo(Item)
